import { useState, useContext, useEffect } from "react";
import ProcessData from "../utils/ProcessData";
import { dataContext } from "../contexts/DataProvider";
import { errorContext } from "../contexts/ErrorProvider";
import { paymentDetailsSchema } from "../validation/schema";
import validate from "../validation/validator";
import { PRECISION } from "../precision";
import {
  bookeeyPaymentMethods,
  initiateBookeeyPayment,
} from "../services/walletService";

const TopupWalletPopup = ({ busy, setBusy, getTransactions }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [data, setData] = useContext(dataContext);
  const [errors, setErrors] = useContext(errorContext);

  const processPaymentDetails = async () => {
    const validation = validate(data, setErrors, paymentDetailsSchema());

    if (validation !== true) return;

    const amountFormatted = Number(
      parseFloat(data?.amount ?? 0).toFixed(PRECISION),
    );

    await initiatePayment(amountFormatted);
  };

  const initiatePayment = async (amountFormatted) => {
    try {
      setIsLoading(true);

      const response = await initiateBookeeyPayment({
        amount: amountFormatted,
        paymentMethod: data?.paymentMethod,
        baseUrl: window.location.origin,
      });

      if (response?.data?.code === 1) {
        window.location.href = response?.data?.data;
      } else {
        setErrors((prev) => ({
          ...prev,
          topup: response?.data?.message,
        }));
      }
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        topup: "Something went wrong",
      }));
    } finally {
      setErrors({});
      setData({});
      setBusy(false);
      setIsLoading(false);
      await getTransactions();
    }
  };

  const fetchPaymentMethods = async () => {
    try {
      const response = await bookeeyPaymentMethods();

      if (response?.data?.code === 1 && Array.isArray(response?.data?.data)) {
        setPaymentMethods(response?.data?.data);
      }
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        topup: "All payment methods are disabled",
      }));
    }
  };

  useEffect(() => {
    fetchPaymentMethods();
    // eslint-disable-next-line
  }, []);

  return (
    <div
      className={
        busy === true
          ? "modal fade effect-slide-in-bottom show bg-success-transparent"
          : "modal fade effect-slide-in-bottom"
      }
      style={busy === true ? { display: "block" } : {}}
      data-bs-backdrop="static"
    >
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content modal-content-demo">
          <div className="modal-header">
            <h6 className="modal-title">Topup Wallet</h6>
            <button
              onClick={() => {
                setBusy((prev) => !prev);
                setData({});
                setErrors({});
              }}
              aria-label="Close"
              className="btn-close"
              data-bs-dismiss="modal"
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body p-0">
            <div className="row mx-0">
              <div className="col-md-12 mt-3">
                {errors?.topup && (
                  <div className="alert alert-solid-danger alert-dismissible fade show">
                    {errors?.topup}
                    <button
                      onClick={() => setErrors({ ...errors, topup: null })}
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="alert"
                      aria-label="Close"
                    >
                      <i className="bi bi-x"></i>
                    </button>
                  </div>
                )}
              </div>
              <div className="col-md-12">
                <div className="card border-0 mb-0">
                  <div className="card-body p-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-2">
                          <label className="form-label">AMOUNT</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="0.000"
                            autoComplete="off"
                            value={data?.amount ?? ""}
                            onChange={(e) => {
                              ProcessData(
                                data,
                                setData,
                                e,
                                "string",
                                "amount",
                                errors,
                                setErrors,
                              );
                            }}
                          />
                          <small className="text-danger">
                            {errors?.amount ?? ""}
                          </small>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-2">
                          <label className="form-label">PAYMENT METHOD</label>
                          <div className="w-100">
                            <div
                              className="btn-group w-100 overflow-x-auto"
                              role="group"
                              aria-label="Basic radio toggle button group"
                            >
                              {Array.isArray(paymentMethods) &&
                                paymentMethods?.map((method) => (
                                  <>
                                    <input
                                      type="radio"
                                      className="btn-check"
                                      name="paymentMethod"
                                      value={method}
                                    />
                                    <label
                                      className={
                                        data?.paymentMethod === method
                                          ? "btn btn-outline-light bg-primary text-light"
                                          : "btn btn-outline-light"
                                      }
                                      onClick={() => {
                                        ProcessData(
                                          data,
                                          setData,
                                          method,
                                          "radio",
                                          "paymentMethod",
                                          errors,
                                          setErrors,
                                        );
                                      }}
                                    >
                                      {method}
                                    </label>
                                  </>
                                ))}
                            </div>
                            <small className="text-danger">
                              {errors?.paymentMethod ?? ""}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer border-top text-center">
                    <div className="ms-auto">
                      <button
                        onClick={processPaymentDetails}
                        className="btn btn-primary"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <span
                            className="spinner-border spinner-border-xs me-1"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          ""
                        )}
                        Pay Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopupWalletPopup;
